import { Badge, variants } from '@uag/react-core';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

const TIMEOUT_DELAY_MS = 2000;

export const ConnectionStatusOverlay = () => {
    const { t } = useTranslation();

    const [visible, setVisible] = useState<boolean>(false);
    const [fadeOut, setFadeOut] = useState<boolean>(false);
    const [isConnected, setIsConnected] = useState<boolean>(usePlacementStore.getState().isHubConnected);

    const fadeTimerRef = useRef<ReturnType<typeof setTimeout>>(undefined);

    useEffect(() => {
        const unsubscribe = usePlacementStore.subscribe(
            (state) => state.isHubConnected,
            (connected, prevConnected) => {
                if (prevConnected === null || connected === prevConnected) {
                    return;
                }

                setIsConnected(connected);

                if (!connected) {
                    clearTimeout(fadeTimerRef.current);
                    setFadeOut(false);
                    setVisible(true);
                } else {
                    setFadeOut(true);
                    fadeTimerRef.current = setTimeout(() => {
                        setVisible(false);
                        setFadeOut(false);
                    }, TIMEOUT_DELAY_MS);
                }
            }
        );

        return () => {
            clearTimeout(fadeTimerRef.current);
            unsubscribe();
        };
    }, []);

    if (!visible) {
        return null;
    }

    return (
        <div className="absolute top-0 left-0 right-0 z-50 flex items-center justify-center pointer-events-none">
            <div className="mt-3 px-4 py-2">
                <Badge
                    icon="info"
                    style={{
                        transition: 'opacity 0.6s ease-out',
                        opacity: fadeOut ? 0 : 1
                    }}
                    variant={isConnected ? variants.badge.success : variants.badge.warning}
                >
                    {isConnected ? t('infoConnectionRestored') : t('infoConnectionLost')}
                </Badge>
            </div>
        </div>
    );
};
